module.exports = __webpack_public_path__ + "static/media/comment-add-svgrepo-com (2).48cbbc27.svg";